import { Action } from '@ngrx/store';

import { HierarchyNode } from '®shared/hierarchy';

import { HierarchyAndStudentNumbers, NodeAndOverride } from '../common';

export enum NodesEditorActionTypes {
  NODES_EDITOR_SHOW_MODAL = '[Nodes editor] show modal',
  NODES_EDITOR_HIDE_MODAL = '[Nodes editor] hide modal',
  NODES_EDITOR_NODES_REQUESTED = '[Nodes editor] nodes and student numbers requested',
  NODES_EDITOR_NODES_LOADED = '[Nodes editor] nodes and student numbers loaded',
  NODES_EDITOR_NODES_LOADING_FAILED = '[Nodes editor] nodes and student numbers loading failed',
  NODES_EDITOR_SAVE_NODES = '[Nodes editor] save nodes and student numbers',
  NODES_EDITOR_SAVE_NODES_SUCCEEDED = '[Nodes editor] saving nodes and student numbers succeeded',
  NODES_EDITOR_SAVE_NODES_FAILED = '[Nodes editor] saving nodes and student numbers failed',
  NODES_EDITOR_NEW_LIST_PERSIST_NODES = '[Nodes editor] persist nodes and student numbers for new list',
  NODES_EDITOR_NEW_LIST_HIDE_MODAL = '[Nodes editor] hide modal for new list',
  NODES_EDITOR_NEW_LIST_SHOW_MODAL = '[Nodes editor] show modal for new list',
}

export interface ListIdAndDraftPayload {
  isDraft: boolean;
  listId: string;
}

export class NodesEditorShowModalAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_SHOW_MODAL;

  constructor(public payload: ListIdAndDraftPayload) {}
}
export class NodesEditorHideModalAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_HIDE_MODAL;

  constructor() {}
}

export interface NodePayload extends ListIdAndDraftPayload {
  node: HierarchyNode;
}

export interface NodeAndOverridePayload
  extends ListIdAndDraftPayload,
    NodeAndOverride {}

export interface HierarchyAndStudentNumbersPayload
  extends ListIdAndDraftPayload {
  hierarchyAndStudentNumbers: HierarchyAndStudentNumbers;
}

export class NodesEditorNodesRequestedAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_NODES_REQUESTED;

  constructor(public payload: ListIdAndDraftPayload) {}
}

export class NodesEditorNodesLoadedAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_NODES_LOADED;

  constructor(public payload: HierarchyAndStudentNumbersPayload) {}
}

export interface NodesLoadingFailedPayload extends ListIdAndDraftPayload {
  error: any;
}

export class NodesEditorNodesLoadingFailedAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_NODES_LOADING_FAILED;

  constructor(public payload: NodesLoadingFailedPayload) {}
}

export class NodesEditorSaveNodesAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_SAVE_NODES;

  constructor(public payload: HierarchyAndStudentNumbersPayload) {}
}

export class NodesEditorSaveNodesSucceededAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_SAVE_NODES_SUCCEEDED;

  constructor(public payload: HierarchyAndStudentNumbersPayload) {}
}

export interface NodesSavingFailedPayload
  extends HierarchyAndStudentNumbersPayload {
  error: any;
}

export class NodesEditorSaveNodesFailedAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_SAVE_NODES_FAILED;

  constructor(public payload: NodesSavingFailedPayload) {}
}

export class NodesEditorNewListPersistNodesAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_NEW_LIST_PERSIST_NODES;

  constructor(public payload: HierarchyAndStudentNumbers) {}
}

export class NodesEditorNewListHideModalAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_NEW_LIST_HIDE_MODAL;
}

export class NodesEditorNewListShowModalAction implements Action {
  readonly type = NodesEditorActionTypes.NODES_EDITOR_NEW_LIST_SHOW_MODAL;
}

export type NodesEditorActions =
  | NodesEditorHideModalAction
  | NodesEditorShowModalAction
  | NodesEditorNodesRequestedAction
  | NodesEditorNodesLoadedAction
  | NodesEditorNodesLoadingFailedAction
  | NodesEditorSaveNodesAction
  | NodesEditorSaveNodesSucceededAction
  | NodesEditorSaveNodesFailedAction
  | NodesEditorNewListPersistNodesAction
  | NodesEditorNewListHideModalAction
  | NodesEditorNewListShowModalAction;
